import { BaseDialog, BaseDialogProps, BaseDialogState } from '../common/dialog/BaseDialog';
import { Grid2 as Grid } from '@mui/material';
import { Button, NumberSelect } from '../common';
import * as React from 'react';
import { PlayerGroupState } from '../../enums';

interface Props extends BaseDialogProps {
    readonly state: PlayerGroupState;
    readonly onUpdate: (state: PlayerGroupState) => void;
}

interface State extends BaseDialogState {
    readonly state: PlayerGroupState;
}

export class ChangeStateGroupPlayerDialog extends BaseDialog<Props, State> {
    state = this.initState();

    componentDidMount() {
        const { state } = this.props;
        this.setState({ state });
    }

    protected renderContent(): React.JSX.Element {
        const {
            state,
        } = this.state;

        const playerGroupStateKeys = Object.keys(PlayerGroupState)
            .filter((key) => Number.isNaN(+key))
            .map((key: string, value: number) => ({
                key,
                value,
            }));

        return (
            <Grid container={true} spacing={0}>
                <Grid size={12}>
                    <NumberSelect
                        label="State"
                        labelId={`select-player-group-sate`}
                        value={state}
                        onChange={this.handleChangeState}
                    >
                        <option key={'Member'} value={PlayerGroupState.Member}>
                            Member
                        </option>
                        <option key={'Admin'} value={PlayerGroupState.Admin}>
                            Admin
                        </option>
                        <option key={'SuperAdmin'} value={PlayerGroupState.SuperAdmin}>
                            SuperAdmin
                        </option>
                    </NumberSelect>
                </Grid>
            </Grid>
        );
    }

    protected renderActions(): React.JSX.Element {
        return (
            <Button text="Change" onClick={this.onUpdate} variant="contained" disabled={!this.validate()} />
        );
    }

    protected initState(): State {
        return {
            state: PlayerGroupState.Member,
        };
    }

    private handleChangeState = (value: number) => {
        const state = value as PlayerGroupState;
        this.setState({ state });
    };

    private onUpdate = () => {
        const { state } = this.state;
        if (!this.validate()) {
            return;
        }
        this.props.onUpdate(state);
        this.onClose();
    };

    private validate(): boolean {
        const { state } = this.state;
        return this.props.state !== state;
    }
}
